// Party Boxes Data
export const partyBoxes = [
  // Baby Shower Boxes
  {
    id: 'soft-launch',
    name: 'The Soft Launch',
    category: 'baby-shower',
    tagline: 'Neutral-toned, Pinterest-perfect',
    vibe: 'Clean, calm, and effortless',
    palette: ['#e8d5d0', '#f5ebe8', '#c4a574', '#ffffff'],
    paletteNames: ['Blush', 'Ivory', 'Gold', 'White'],
    image: '/images/soft-launch.jpg',
    guestRange: '6–10',
    setupTime: '60–75 minutes',
    idealFor: 'Baby showers, mommy brunches, gender-neutral celebrations',
    includes: [
      'Linen table runner (neutral or blush)',
      'Mini dried floral bundles or pampas stems',
      '"Oh Baby" or customizable signage',
      'Disposable plates, cutlery & napkins (muted aesthetic)',
      'Clear coupe cups + mom-osa bar tags',
      'Banner or backdrop fabric',
      'Digital setup guide + mocktail bar ideas',
      'Printable game cards: "Name that Baby Tune," "Advice for Parents"',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide PDF, links, setup instructions, moodboard' },
      { name: 'Standard Box', price: '$175', includes: 'Decor, signage, premium disposables' },
      { name: 'Luxe Box', price: '$325', includes: 'Upgraded linens, candles, printed menus, full styling kit' }
    ],
    addons: [
      { name: 'Personalized name cards', price: '$15' },
      { name: 'Balloon bundle', price: '$25' },
      { name: 'Local setup (select areas)', price: '$150+' }
    ]
  },
  {
    id: 'twinkle-star',
    name: 'Twinkle Little Star',
    category: 'baby-shower',
    tagline: 'A little star is on the way',
    vibe: 'Soft, dreamy celestial theme',
    palette: ['#b8d4e3', '#c4a574', '#ffffff', '#f5ebe8'],
    paletteNames: ['Baby Blue/Blush', 'Gold', 'White', 'Cream'],
    image: '/images/twinkle-star.jpg',
    guestRange: '8–15',
    setupTime: '45–60 minutes',
    idealFor: 'Baby showers, nursery reveals',
    includes: [
      'Moon & star garland',
      'White & gold tableware',
      'Star-shaped cookies or favor tags',
      'Balloon garland (white, gold, pastel)',
      'Baby prediction game cards',
      'Celestial drink recipe card',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide PDF, printables, moodboard' },
      { name: 'Standard Box', price: '$165', includes: 'Decor, tableware, games' },
      { name: 'Luxe Box', price: '$295', includes: 'Full kit with balloons and premium items' }
    ],
    addons: [
      { name: 'Custom banner', price: '$20' },
      { name: 'Favor bags (set of 10)', price: '$25' }
    ]
  },
  
  // Birthday Boxes
  {
    id: 'dirty-thirty',
    name: 'Dirty Thirty',
    category: 'birthday',
    tagline: 'You\'re not older, you\'re iconic',
    vibe: 'Sexy, grown-up, gold-accented drama',
    palette: ['#1a1a1a', '#c4a574', '#f5ebe8', '#722f37'],
    paletteNames: ['Black', 'Gold', 'Nude', 'Wine'],
    image: '/images/dirty-thirty.jpg',
    guestRange: '4–10',
    setupTime: '45–60 minutes',
    idealFor: '30th birthdays, milestone celebrations, chic backyard dinners',
    includes: [
      'Matte black & gold place settings',
      '"Thirty AF" or "You\'re Not Old, You\'re Iconic" signage',
      'Taper candles + wine-toned napkins',
      'Quote cards + printed menus',
      'Birthday crown',
      'Printable invites & story templates',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide PDF, printables' },
      { name: 'Standard Box', price: '$195', includes: 'Full decor kit with tableware' },
      { name: 'Luxe Box', price: '$350', includes: 'Premium items, candles, custom signage' }
    ],
    addons: [
      { name: 'Champagne flutes (set of 4)', price: '$30' },
      { name: 'Custom cake topper', price: '$25' },
      { name: 'Photo backdrop', price: '$45' }
    ]
  },
  {
    id: 'midnight-milestone',
    name: 'Midnight Milestone',
    category: 'birthday',
    tagline: 'Another year bolder',
    vibe: 'Elegant, grown-up birthday — gold, black, champagne accents',
    palette: ['#1a1a1a', '#c4a574', '#f5ebe8', '#e8e8e8'],
    paletteNames: ['Black', 'Gold', 'Blush', 'Pearl'],
    image: '/images/midnight.jpg',
    guestRange: '6–12',
    setupTime: '45–60 minutes',
    idealFor: 'Milestone birthdays, classy house parties, backyard toasts',
    includes: [
      'Black sequin table runner',
      'Gold foil tableware',
      'Personalized "Cheers to [Age]" banner',
      'Confetti poppers',
      'Mini champagne bottles with custom labels',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Design guide, printables' },
      { name: 'Standard Box', price: '$185', includes: 'Decor, tableware, banner' },
      { name: 'Luxe Box', price: '$325', includes: 'Full kit with champagne accessories' }
    ],
    addons: [
      { name: 'Sparkler candles', price: '$15' },
      { name: 'Photo booth props', price: '$25' }
    ]
  },
  {
    id: 'cool-mom',
    name: 'The Cool Mom',
    category: 'birthday',
    tagline: 'Moody minimalism meets Pinterest-core',
    vibe: 'Sophisticated, candlelit elegance',
    palette: ['#9a7b9a', '#722f37', '#c4a574', '#1a1a1a'],
    paletteNames: ['Mauve', 'Wine', 'Taupe', 'Black'],
    image: '/images/cool-mom.jpg',
    guestRange: '6–12',
    setupTime: '45–60 minutes',
    idealFor: 'Milestone birthdays, backyard wine nights',
    includes: [
      'Cloth napkins or luxe paper alternatives',
      'Customizable birthday signage',
      'Candle sticks + holders (black or gold)',
      'Floral centerpiece (faux or dried)',
      'Chic paper plates + heavy matte cutlery',
      'Conversation card deck',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide, moodboard, printables' },
      { name: 'Standard Box', price: '$195', includes: 'Full tabletop decor' },
      { name: 'Luxe Box', price: '$335', includes: 'Premium linens and candles' }
    ],
    addons: [
      { name: 'Birthday crown or headband', price: '$15' },
      { name: 'Wine glass markers', price: '$12' }
    ]
  },
  
  // Bachelorette Boxes
  {
    id: 'til-death',
    name: 'Til Death Do Us Party',
    category: 'bachelorette',
    tagline: 'Skip the cringe. Bring the candles.',
    vibe: 'Moody, hot, chaotic—in the best way',
    palette: ['#1a1a1a', '#ffffff', '#c4a574', '#ff69b4'],
    paletteNames: ['Black', 'White', 'Gold', 'Hot Pink'],
    image: '/images/till-death.jpg',
    guestRange: '6–12',
    setupTime: '60–75 minutes',
    idealFor: 'Backyard bachelorettes, airbnb nights, alt brides',
    includes: [
      'Bachelorette signage & convo cards',
      'Candle bundle + moody tableware',
      'Glitter stirrers & name tags',
      'Game cards ("Bach or Bust")',
      'Bride sash (optional)',
      'Disco ball drink stirrers',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide, games, printables' },
      { name: 'Standard Box', price: '$185', includes: 'Full party kit' },
      { name: 'Luxe Box', price: '$365', includes: 'Premium items, extra games, matching accessories' }
    ],
    addons: [
      { name: 'Hangover kit supplies', price: '$35' },
      { name: 'Matching robes (set of 4)', price: '$80' },
      { name: 'Custom shot glasses', price: '$25' }
    ]
  },
  {
    id: 'hot-bach',
    name: 'Hot Bach Summer',
    category: 'bachelorette',
    tagline: 'One last night to sparkle',
    vibe: 'Spicy, fun, curated—not tacky',
    palette: ['#ff69b4', '#ff0000', '#f5ebe8', '#e8e8e8'],
    paletteNames: ['Hot Pink', 'Red', 'Blush', 'Sparkle'],
    image: '/images/hot-bach.jpg',
    guestRange: '6–12',
    setupTime: '60–75 minutes',
    idealFor: 'Backyard bach, weekend house rental party',
    includes: [
      '"Last Fling" or "Til Death Do Us Party" signage',
      'Disco ball drink stirrers + pink coupe glasses',
      'Printable game cards: "Bach or Bust," "Who Said That?"',
      'Candle tin + glitter confetti + blush tableware',
      'Bride sash + team bride name tags',
      'Social photo prompt signs',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Digital planning guide' },
      { name: 'Standard Box', price: '$205', includes: 'Party decor kit' },
      { name: 'Luxe Box', price: '$375', includes: 'Full experience with extras' }
    ],
    addons: [
      { name: 'Hangover/recovery station setup', price: '$40' },
      { name: 'Personalized tote bags', price: '$45' }
    ]
  },
  {
    id: 'veil-vino',
    name: 'Veil & Vino',
    category: 'bachelorette',
    tagline: 'Sip, sparkle, say "I do"',
    vibe: 'Glam wine night with girlfriends',
    palette: ['#d4a5a5', '#f5ebe8', '#ffffff', '#c4a574'],
    paletteNames: ['Rose Gold', 'Blush', 'White', 'Gold'],
    image: '/images/veil-vino.jpg',
    guestRange: '6–10',
    setupTime: '45–60 minutes',
    idealFor: 'Wine-loving brides, intimate celebrations',
    includes: [
      'Rose gold foil tableware',
      'Bride sash & mini veil',
      'Personalized champagne flutes',
      'Rose gold confetti',
      'Mini rosé bottles',
      '"Bride Tribe" cupcake toppers',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Planning guide, printables' },
      { name: 'Standard Box', price: '$175', includes: 'Decor and tableware' },
      { name: 'Luxe Box', price: '$315', includes: 'Full kit with glassware' }
    ],
    addons: [
      { name: 'Wine charms (set of 8)', price: '$18' },
      { name: 'Matching headbands', price: '$30' }
    ]
  },
  
  // Dinner Party / Brunch Boxes
  {
    id: 'book-club-hot',
    name: 'Book Club But Make It Hot',
    category: 'dinner-party',
    tagline: 'Your monthly reading crew just got an aesthetic upgrade',
    vibe: 'Feminine academia + candlelit elegance',
    palette: ['#722f37', '#f5ebe8', '#d4a5a5', '#c4a574'],
    paletteNames: ['Burgundy', 'Ivory', 'Dusty Pink', 'Gold'],
    image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80',
    guestRange: '4–8',
    setupTime: '35–45 minutes',
    idealFor: 'Book club dinners, small dinners, creative birthdays',
    includes: [
      'Mini vintage book stack decor',
      'Menu cards with literary puns',
      'Cloth or linen table runner',
      'Wine glass markers (gold ink pens + tags)',
      'Faux taper candles + holders',
      'Quote cards for each place setting',
      'Printable invite + IG story templates',
      'Styling guide for outdoor layout + lighting tips',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'PDF guide, printables, sourcing links' },
      { name: 'Standard Box', price: '$195', includes: 'Full styling kit' },
      { name: 'Luxe Box', price: '$350', includes: 'Premium decor with custom touches' }
    ],
    addons: [
      { name: 'Book pairing recommendations', price: '$15' },
      { name: 'Custom bookmarks (set of 8)', price: '$20' }
    ]
  },
  {
    id: 'citrus-sage',
    name: 'Citrus & Sage',
    category: 'brunch',
    tagline: 'Light, crisp, and golden-hour ready',
    vibe: 'Whimsical, sunset-inspired garden glam',
    palette: ['#9caf88', '#ffffff', '#f5d76e', '#f5ebe8'],
    paletteNames: ['Sage Green', 'White', 'Lemon Yellow', 'Blush'],
    image: '/images/citrus-sage.jpg',
    guestRange: '6–10',
    setupTime: '45–60 minutes',
    idealFor: 'Bridal showers, garden brunches, housewarmings',
    includes: [
      'Lemon or citrus garland centerpiece',
      'Linen runner + paper placemats',
      'Floral drink stirrers + brunch signage',
      'Disposable coupe cups + pressed flower coasters',
      'Printable menu and seating cards',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Planning guide, printables' },
      { name: 'Standard Box', price: '$165', includes: 'Decor kit' },
      { name: 'Luxe Box', price: '$285', includes: 'Full styling package' }
    ],
    addons: [
      { name: 'Balloon bundle', price: '$25' },
      { name: 'Fresh herb centerpiece guide', price: '$10' }
    ]
  },
  {
    id: 'peach-please',
    name: 'Peach Please',
    category: 'brunch',
    tagline: 'Golden hour, fresh fruit, zero effort',
    vibe: 'Whimsical, sunset-inspired',
    palette: ['#f5cac3', '#f5ebe8', '#c4a574', '#ffffff'],
    paletteNames: ['Peach', 'Blush', 'Gold', 'White'],
    image: '/images/peach-please.jpg',
    guestRange: '6–10',
    setupTime: '45–60 minutes',
    idealFor: 'Bridal showers, summer birthdays, garden hangs',
    includes: [
      'Peach-toned table runner',
      'Gold-rimmed disposable plates',
      'Floral centerpiece elements',
      'Brunch signage ("Sip Happens")',
      'Disposable coupe glasses',
      'Menu & seating templates',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide and printables' },
      { name: 'Standard Box', price: '$165', includes: 'Basic decor package' },
      { name: 'Luxe Box', price: '$285', includes: 'Full styling kit' }
    ],
    addons: [
      { name: 'Balloon bundle', price: '$25' },
      { name: 'Mimosa bar labels', price: '$12' }
    ]
  },
  {
    id: 'grown-grapeful',
    name: 'Grown & Grapeful',
    category: 'dinner-party',
    tagline: 'You bring the wine. We bring the ambiance.',
    vibe: 'Warm, rich, slow luxury',
    palette: ['#5c3d2e', '#722f37', '#f5ebe8', '#c4a574'],
    paletteNames: ['Terracotta', 'Wine', 'Cream', 'Gold'],
    image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=800&q=80',
    guestRange: '4–8',
    setupTime: '30–40 minutes',
    idealFor: 'Low-key birthdays, introvert-friendly girls\' nights, wine nights',
    includes: [
      'Wine tasting cards + gold pens',
      'Candle set (unscented) + wine quote cards',
      'Menu template + grazing guide',
      'Acrylic wine tags + charcuterie labels',
      'Conversation card deck ("Truth or Terribly Fancy")',
      'Linen table runner',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Guide, printables, recipe cards' },
      { name: 'Standard Box', price: '$155', includes: 'Decor and accessories' },
      { name: 'Luxe Box', price: '$275', includes: 'Full kit with premium items' }
    ],
    addons: [
      { name: 'Blind tasting game', price: '$20' },
      { name: 'Custom wine labels (set of 4)', price: '$18' }
    ]
  },
  
  // Themed Party Boxes
  {
    id: 'champagne-picnic',
    name: 'Champagne Problems Picnic',
    category: 'themed',
    tagline: 'Aesthetically soft, emotionally chaotic',
    vibe: 'Layered rugs, velvet pillows, soft string lights, light sarcasm',
    palette: ['#f5ebe8', '#c4a574', '#d4a5a5', '#9caf88'],
    paletteNames: ['Cream', 'Gold', 'Blush', 'Sage'],
    image: '/images/champagne-problems.jpg',
    guestRange: '2–6',
    setupTime: '30–45 minutes',
    idealFor: 'Intimate outdoor gatherings, romantic picnics, small celebrations',
    includes: [
      'Moodboard + layout diagram',
      'Printable quote cards or signage',
      'Tablescape kit with candles + runners',
      'Disposable elegant serveware',
      'Setup instructions',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'PDF guide, printables, moodboard' },
      { name: 'Standard Box', price: '$195', includes: 'Full picnic styling kit' },
      { name: 'Luxe Box', price: '$350', includes: 'Premium decor with velvet touches' }
    ],
    addons: [
      { name: 'Handwritten quote menus', price: '$25' },
      { name: 'Emotional support snack kits', price: '$20' }
    ]
  },
  {
    id: 'garden-gala',
    name: 'Low-Key Garden Gala',
    category: 'themed',
    tagline: 'Cottagecore but minimal',
    vibe: 'White tablecloths, fresh herbs, citrus centerpieces, wildflower bundles',
    palette: ['#ffffff', '#9caf88', '#f5d76e', '#f5ebe8'],
    paletteNames: ['White', 'Sage', 'Citrus', 'Cream'],
    image: '/images/garden-gala.jpg',
    guestRange: '6–12',
    setupTime: '45–60 minutes',
    idealFor: 'Garden parties, outdoor celebrations, casual elegance',
    includes: [
      'Setup diagram + styling instructions',
      'Grocery store flower guide',
      'Menu template + signage file',
      'White linen-look table runner',
      'Herb sprig place card holders',
      'Citrus centerpiece guide',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'PDF guide and printables' },
      { name: 'Standard Box', price: '$215', includes: 'Full decor kit' },
      { name: 'Luxe Box', price: '$385', includes: 'Premium styling with linens' }
    ],
    addons: [
      { name: 'DIY bouquet kit partnership', price: '$45' },
      { name: 'Place card personalization', price: '$15' }
    ]
  },
  {
    id: 'rose-ramen',
    name: 'Backyard Rosé & Ramen',
    category: 'themed',
    tagline: 'Unexpected combos, beautiful results',
    vibe: 'Blush-toned color palette, lanterns and cozy lighting',
    palette: ['#f5cac3', '#f5ebe8', '#ffffff', '#c4a574'],
    paletteNames: ['Peach', 'Nude', 'White', 'Gold'],
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800&q=80',
    guestRange: '4–8',
    setupTime: '35–45 minutes',
    idealFor: 'Unique dinner parties, friends gatherings',
    includes: [
      'Decor scheme guide (peach, nude, white)',
      'Ramen bar menu planning PDF',
      'Lantern string lighting plan',
      'Table styling guide + candle layout',
      'Disposable but beautiful plateware sourcing list',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Complete planning guide' },
      { name: 'Standard Box', price: '$195', includes: 'Decor elements' },
      { name: 'Luxe Box', price: '$350', includes: 'Full styling with premium items' }
    ],
    addons: [
      { name: 'Sake cup set', price: '$25' },
      { name: 'Custom menu cards', price: '$18' }
    ]
  },
  {
    id: 'glam-glow',
    name: 'Glam & Glow Party',
    category: 'themed',
    tagline: 'Chic, sparkly, Instagram-ready',
    vibe: 'Luxe glam with a hint of glow-up magic',
    palette: ['#c4a574', '#d4a5a5', '#1a1a1a', '#ffffff'],
    paletteNames: ['Gold', 'Rose Gold', 'Black', 'White'],
    image: '/images/glam-glow.jpg',
    guestRange: '6–10',
    setupTime: '45–60 minutes',
    idealFor: 'Glam nights, Instagram-worthy celebrations',
    includes: [
      'Mini LED string lights or fairy lights',
      'Glitter face/body decals & cosmetic glitter',
      'Satin or velvet table runner in metallic shades',
      'Custom cocktail recipe card',
      'Gold or rose gold cutlery & confetti',
      'Stylish reusable party cups with straws',
      'Selfie props & backdrop DIY kit',
      'Themed Extras'
    ],
    tiers: [
      { name: 'DIY Digital', price: '$60', includes: 'Basic elements and guide' },
      { name: 'Standard Box', price: '$175', includes: 'Full decor kit' },
      { name: 'Luxe Box', price: '$320', includes: 'Full glam kit with skincare items' }
    ],
    addons: [
      { name: 'Sheet mask set', price: '$15' },
      { name: 'LED mirror', price: '$25' }
    ]
  }
];

// Categories for filtering
export const boxCategories = [
  { id: 'all', name: 'All Boxes' },
  { id: 'baby-shower', name: 'Baby Shower' },
  { id: 'birthday', name: 'Birthday' },
  { id: 'bachelorette', name: 'Bachelorette' },
  { id: 'brunch', name: 'Brunch' },
  { id: 'dinner-party', name: 'Dinner Party' },
  { id: 'themed', name: 'Themed Parties' }
];

export default partyBoxes;
